// test2606
(2606 && 0);
